export default __webpack_public_path__ + "static/media/macTech1.7fa66f1f.png";